import PropTypes from 'prop-types'
import React from 'react'

import TooltipInfo from 'components/TooltipInfo'

import bacteriaDark from './assets/bacteria_black.svg'
import bacteriaWhite from './assets/bacteria_white.svg'
import calendarDark from './assets/calendar_black.svg'
import calendarWhite from './assets/calendar_white.svg'

/**
 * SubscriptionInfo
 *
 * @param {object} props - properties of component
 * @returns {node} SubscriptionInfo
 */
const SubscriptionInfo = props => {
  const { texts, whiteTheme } = props
  const calendarSrc = whiteTheme ? calendarDark : calendarWhite
  const bacteriaSrc = whiteTheme ? bacteriaDark : bacteriaWhite
  const data = [
    {
      icon: calendarSrc,
      title: texts.time_title,
      descr: texts.time_descr,
    },
    {
      icon: bacteriaSrc,
      title: texts.cancel_title,
      descr: texts.cancel_descr,
    },
  ]

  return <TooltipInfo data={data} />
}

SubscriptionInfo.propTypes = {
  /** Object with texts for subscription */
  texts: PropTypes.object.isRequired,

  /** Colors for white background */
  whiteTheme: PropTypes.bool,
}

SubscriptionInfo.defaultProps = {
  whiteTheme: false,
}

export default SubscriptionInfo
